import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import FCLogo from "../../Assets/Images/fucascore_png.png";

const FSAdminHome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) {
        navigate("/admin-login");
        return;
      }

      const { data: isAdmin } = await supabase
        .from("admin_users")
        .select("id")
        .eq("id", user.id)
        .single();

      if (!isAdmin) {
        navigate("/");
      } else {
        setLoading(false);
      }
    };
    checkAccess();
  }, [navigate]);

  if (loading) return <div className="admin-wrapper">Provjera ovlasti...</div>;

  return (
    <div className="fs-admin-custom">
      {/* Fiksna navigacija */}
      <nav className="admin-navbar">
        <a href="/fucascore-admin">
          <img src={FCLogo} alt="FucaScore logo" className="logo" />
        </a>
        <div className="title">FucaScore Teo</div>
        <button
          className="logout-btn"
          onClick={async () => {
            await supabase.auth.signOut();
            navigate("/admin-login");
          }}
        >
          Odjava
        </button>
      </nav>

      {/* Sadržaj */}
      <div className="admin-content">
        <div className="admin-header">
          <h1>Admin Panel</h1>
          <p>Dobrodošao nazad, Teo.</p>
        </div>

        <div className="admin-grid">
          <div
            className="admin-card"
            onClick={() => navigate("/fs-add-turnir")}
          >
            <i
              className="fi fi-rs-plus-small"
              style={{ color: "#5ef1bbff" }}
            ></i>
            <span>Dodaj Turnir</span>
            <i className="fi fi-rs-angle-small-right"></i>
          </div>

          {/* NOVA KARTICA ZA GLOBALNE EKIPE */}
          <div
            className="admin-card"
            onClick={() => navigate("/fs-admin-all-teams")}
          >
            <i className="fi fi-rs-shield" style={{ color: "#3498db" }}></i>
            <span>Sve Ekipe (Baza)</span>
            <i className="fi fi-rs-angle-small-right"></i>
          </div>

          <div className="admin-card" onClick={() => {}}>
            <i className="fi fi-rs-settings" style={{ color: "#ccc12eff" }}></i>
            <span>Sve Postavke</span>
            <i className="fi fi-rs-angle-small-right"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FSAdminHome;
